export const ONE_TIME = 'One Time';
export const MONTHLY = 'Monthly';
export const YEARLY = 'Yearly';

export enum Frequency {
  ONE_TIME = 'One Time',
  MONTHLY = 'Monthly',
  YEARLY = 'Yearly',
}
